import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import wfHelperMixin from './biz/mixins/wf-helper'
import router from './router'
import FastClick from 'fastclick'
import mintUI from './middle/mint-ui'
import customFilter from './middle/filter/main'
import stores from './store/index'
import { Overlay, Checkbox, CheckboxGroup, Popup,Tab, Tabs, Button ,Loading, Toast,Form,Field,CellGroup,Cell,Image as VanImage,Picker,Empty, Divider , Uploader, NavBar, RadioGroup, Radio  } from 'vant';
import globalComponents from './middle/global-components'
import Clipboard from 'v-clipboard'
import VueCanvasPoster from "vue-canvas-poster";
import { Col, Row } from "vant";
import PerfectScrollbar from 'vue2-perfect-scrollbar'

// import deviceIsIOS from

import 'babel-polyfill'
import 'vant/lib/index.css'

console.log(navigator.userAgent)

FastClick.prototype.focus = function (targetElement) {
  let length
  let deviceIsIOS = !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  console.log(navigator.userAgent)
  console.log(deviceIsIOS)
  // 兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
  // 这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
    length = targetElement.value.length
    targetElement.setSelectionRange(length, length)
    /* 修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘 */
    targetElement.focus()
  } else {
    targetElement.focus()
  }
}

FastClick.attach(document.body)

if (process.env.NODE_ENV !== 'production' || /vconsole=true/.test(location.href)) {
  const VConsole = require('vconsole')
  // eslint-disable-next-line
  new VConsole()
}

Vue.mixin(wfHelperMixin)

Vue.use(globalComponents)
Vue.use(customFilter)
Vue.use(mintUI)
Vue.use(Vuex)
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup );
Vue.use(Cell );
Vue.use(VanImage);
Vue.use(Picker);
Vue.use(Empty);
Vue.use(Uploader);
Vue.use(Divider);
Vue.use(Clipboard);
Vue.use(VueCanvasPoster);
Vue.use(NavBar);
Vue.use(Overlay);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup)
Vue.use(Col);
Vue.use(Row);
Vue.use(PerfectScrollbar)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: stores
})
new Vue({
  router,
  store,
  render: (h) => (
    // !! h 必须要传 render内部会使用到
    <App />
  )
}).$mount('#app') // el: '#app'
